var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9017_66772",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 20 0.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9017_66772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95817 17.1654C11.8193 17.1654 13.4026 16.5195 14.7082 15.2279C16.0137 13.9362 16.6665 12.3598 16.6665 10.4987L16.6665 10.3529L17.9998 11.6862L19.1665 10.5195L15.8332 7.1862L12.4998 10.5195L13.6665 11.6862L14.9998 10.3529L14.9998 10.4987C14.9998 11.8876 14.5103 13.0681 13.5311 14.0404C12.5519 15.0126 11.3609 15.4987 9.95817 15.4987C9.59706 15.4987 9.24289 15.457 8.89567 15.3737C8.54845 15.2904 8.20817 15.1654 7.87484 14.9987L6.62484 16.2487C7.15262 16.5543 7.69428 16.7834 8.24984 16.9362C8.80539 17.089 9.37484 17.1654 9.95817 17.1654ZM4.1665 13.8112L7.49984 10.4779L6.33317 9.3112L4.99984 10.6445L4.99984 10.4987C4.99984 9.10981 5.48942 7.92925 6.46859 6.95703C7.44775 5.98481 8.63873 5.4987 10.0415 5.4987C10.4026 5.4987 10.7568 5.54037 11.104 5.6237C11.4512 5.70703 11.7915 5.83203 12.1248 5.9987L13.3748 4.7487C12.8471 4.44314 12.3054 4.21398 11.7498 4.0612C11.1943 3.90842 10.6248 3.83203 10.0415 3.83203C8.18039 3.83203 6.59706 4.47787 5.2915 5.76953C3.98595 7.0612 3.33317 8.63759 3.33317 10.4987L3.33317 10.6445L1.99984 9.3112L0.833171 10.4779L4.1665 13.8112Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.09a36985e9ed8147ff176c995cd46af4.svg";
export { ForwardRef as ReactComponent };